import React from "react";
import { useLocale } from "../i18n";

/**
 * Skip link — first tab-stop on every page. Jumps to <main id="main-content">.
 * Only becomes visible while focused (screen-reader accessible anytime).
 */
export default function SkipLink() {
  const { locale } = useLocale();
  return (
    <a
      href="#main-content"
      data-testid="skip-link"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-3 focus:bg-[var(--wr-ink)] focus:text-[var(--wr-bg)] focus:font-mono-wr focus:text-[12px] focus:uppercase focus:tracking-widest focus:rounded-sm"
    >
      {locale === "ro" ? "Sari la conținut" : "Skip to content"}
    </a>
  );
}
